import React from "react";
import "../Pages/CSS/PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <h1>Privacy Policy</h1>

      <section>
        <h2>Introduction</h2>
        <p>
          At Hesham Ali Collection, we value your privacy and are committed to
          protecting your personal information. This privacy policy explains
          how we collect, use, and safeguard your data when you use our
          website and services.
        </p>
      </section>

      <section>
        <h2>Information We Collect</h2>
        <p>
          We may collect the following types of information:
        </p>
        <ul>
          <li>Personal details (name, email, phone number, shipping address)</li>
          <li>Account information if you create an account with us</li>
          <li>Payment information during checkout (securely processed)</li>
          <li>Browsing behavior on our website (pages visited, clicks)</li>
        </ul>
      </section>

      <section>
        <h2>How We Use Your Information</h2>
        <ul>
          <li>To process and deliver your orders</li>
          <li>To communicate order updates and promotions</li>
          <li>To improve our website and services</li>
          <li>To prevent fraud and ensure secure transactions</li>
        </ul>
      </section>

      <section>
        <h2>Cookies</h2>
        <p>
          Our website uses cookies to enhance your browsing experience. Cookies
          help us remember your preferences and track website performance. You
          can disable cookies in your browser settings, but some features may
          not work properly.
        </p>
      </section>

      <section>
        <h2>Data Sharing</h2>
        <p>
          We do not sell your personal information to third parties. We may
          share your data with trusted service providers to process orders or
          for website maintenance.
        </p>
      </section>

      <section>
        <h2>Security</h2>
        <p>
          We use industry-standard security measures such as SSL encryption to
          protect your personal and payment information.
        </p>
      </section>

      <section>
        <h2>Contact Us</h2>
        <p>
          If you have any questions regarding this privacy policy or your
          personal data, please contact us at:
        </p>
        <p>Email: zainarshad624@gmail.com</p>
        <p>Phone: +92311-588-6603</p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
